import { Input, InputProps } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useDebounce from "../hooks/useDebounce";
import useQueryParams from "../hooks/useQueryParams";

export interface ISearchProps extends InputProps {
  name: string;
}

export default function Search({ name, ...props }: ISearchProps) {
  const query = useQueryParams();
  const [term, setTerm] = useState(query.secureGet(name + "term")?.toString() || "");
  const debouncedQuery = useDebounce(term, 400);
  const { t } = useTranslation();

  useEffect(() => {
    if (debouncedQuery && debouncedQuery.trim() !== "") {
      query.set(name + "term", debouncedQuery.trim());
    } else {
      query.remove(name + "term");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedQuery]);

  return (
    <Input
      {...props}
      allowClear
      className="headermargin_r"
      size="large"
      style={{ width: "180px" }}
      value={term}
      onChange={(evt) => setTerm(evt.target.value)}
      placeholder={t("search") || t("searchDots")}
    />
  );
}
// s47 (Boshliq 2026-09-07): Поиск sarlavhada qoladi (Фильтр oynasiga tushmaydi) — Header shu belgi bilan taniydi
(Search as any).isHeaderSearch = true
